angular.module('impactx.toolbar').controller('SearchFilterToggleCtrl', [
    'ToolbarService',
    'themeFactory',
    'SearchFilter',
    SearchFilterToggleController
]);

function SearchFilterToggleController(ToolbarService, themeFactory, SearchFilter) {
    var self = this;
    self.theme = themeFactory.getTheme;
    self.showSearchFilterToggle = ToolbarService.showSearchFilter;
    self.toggleFilterSidebar = SearchFilter.toggleFilterSidebar;
    self.isOpen = SearchFilter.isOpen;
    self.selectedFilter = SearchFilter.selectedFilter;
}